import {getBulkActionSlice} from 'src/components/bulk-tool';

import type {
    BulkActionIdSelector,
    BulkActionShownSelector,
    BulkActionTaskSelector,
} from 'src/components/bulk-tool';

export const assignProductAccountEntitlementsSlice = getBulkActionSlice(
    'assignProductAccountEntitlementsResult',
);

export const selectAssignProductAccountEntitlementsShown: BulkActionShownSelector = state =>
    state.bulkUpdateResult.assignProductAccountEntitlementsResult.shown;

export const selectAssignProductAccountEntitlementsBulkUuid: BulkActionIdSelector = state =>
    state.bulkUpdateResult.assignProductAccountEntitlementsResult.uuid;

export const selectAssignProductAccountEntitlementsTask: BulkActionTaskSelector = state =>
    state.bulkUpdateResult.assignProductAccountEntitlementsResult.backgroundTask;

export const {
    setUuid,
    setBackgroundTask,
    setShown,
    clearResult,
} = assignProductAccountEntitlementsSlice.actions;
